import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Icon from 'srcReact/components/icons/Icon'
import ToggleSwitch from 'srcReact/components/common2/ToggleSwitch'
import { urlSearchParams } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'

export default function OptionsToggle({ id_type, toggle_type, options, handleOptions }) {
  const { t } = useTranslation()

  const { isNative } = useSelector((state) => state.common)
  const { current_organization } = useSelector((state) => state.organization)
  const { groupDetails } = useSelector((state) => state.settings)

  const email =
    toggle_type === 'global'
      ? options && options.email
      : options && options.email && options.email.users_setting === 1
      ? true
      : false
  const push =
    toggle_type === 'global'
      ? options && options.push
      : options && options.push && options.push.users_setting === 1
      ? true
      : false
  const app =
    toggle_type === 'global'
      ? options && options.app
      : options && options.app && options.app.users_setting === 1
      ? true
      : false

  const handleToggle = (type) => {
    if (type === 'email') {
      const payload = {
        notification_id: options && options.id_notification_setting,
        id: 0,
        type,
        id_type,
        value: !email ? 1 : 0,
        id_organization: isNative ? urlSearchParams('organization_id') : current_organization.info.id,
        group_id: groupDetails.id,
        group_role: groupDetails.role
      }
      handleOptions(payload)
    } else if (type === 'push') {
      const payload = {
        notification_id: options && options.id_notification_setting,
        id: 0,
        type,
        id_type,
        value: !push ? 1 : 0,
        id_organization: isNative ? urlSearchParams('organization_id') : current_organization.info.id,
        group_id: groupDetails.id,
        group_role: groupDetails.role
      }
      handleOptions(payload)
    } else if (type === 'app') {
      const payload = {
        notification_id: options && options.id_notification_setting,
        id: 0,
        type,
        id_type,
        value: !app ? 1 : 0,
        id_organization: isNative ? urlSearchParams('organization_id') : current_organization.info.id,
        group_id: groupDetails.id,
        group_role: groupDetails.role
      }
      handleOptions(payload)
    }
  }

  return (
    <div className={`${styles.toggleBlock}`}>
      {toggle_type === 'global' || options.email.is_exist === 1 ? (
        <div className={`${styles.options}`}>
          <div className={`${styles.optionsTextBlock}`}>
            <Icon name='mail-close' styleModifier={styles.icon} alt='' />
            <h2>{t('notification_settings.options.emailTitle')}</h2>
          </div>
          <ToggleSwitch
            isChecked={email}
            height={25}
            onChange={() => {
              handleToggle('email')
            }}
          />
        </div>
      ) : (
        ''
      )}
      {toggle_type === 'global' || options.push.is_exist === 1 ? (
        <div className={`${styles.options}`}>
          <div className={`${styles.optionsTextBlock}`}>
            <Icon name='computer' styleModifier={styles.icon} alt='' />
            <h2>{t('notification_settings.options.pushTitle')}</h2>
          </div>
          <ToggleSwitch
            isChecked={push}
            height={25}
            onChange={() => {
              handleToggle('push')
            }}
          />
        </div>
      ) : (
        ''
      )}
      {toggle_type === 'global' || options.app.is_exist === 1 ? (
        <div className={`${styles.options}`}>
          <div className={`${styles.optionsTextBlock}`}>
            <Icon name='phone' styleModifier={styles.icon} alt='' />
            <h2>{t('notification_settings.options.appTitle')}</h2>
          </div>
          <ToggleSwitch
            isChecked={app}
            height={25}
            onChange={() => {
              handleToggle('app')
            }}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
